import Vue from 'vue';
import { Tag, Row, Col, List, Tree, Spin, Menu, Icon, Card, Tabs, Form, Space, Empty, Steps, Alert, Badge, Input, Modal, Table, Radio, Switch, Anchor, Result, Drawer, Select, Button, Layout, Avatar, Upload, Popover, Tooltip, message, Divider, Comment, Cascader, Collapse, Calendar, Carousel, Timeline, Dropdown, Checkbox, Progress, Skeleton, Transfer, FormModel, TreeSelect, Breadcrumb, DatePicker, PageHeader, Popconfirm, Pagination, InputNumber, notification, Descriptions, ConfigProvider, Statistic, BackTop, TimePicker, Rate } from 'ant-design-vue';

Vue.use(Tag);
Vue.use(Row);
Vue.use(Col);
Vue.use(Form);
Vue.use(List);
Vue.use(Tree);
Vue.use(Spin);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Tabs);
Vue.use(Card);
Vue.use(Space);
Vue.use(Alert);
Vue.use(Empty);
Vue.use(Steps);
Vue.use(Modal);
Vue.use(Badge);
Vue.use(Input);
Vue.use(Table);
Vue.use(Radio);
Vue.use(Anchor);
Vue.use(Result);
Vue.use(Drawer);
Vue.use(Upload);
Vue.use(Button);
Vue.use(Layout);
Vue.use(Avatar);
Vue.use(Select);
Vue.use(Switch);
Vue.use(BackTop);
Vue.use(Comment);
Vue.use(Tooltip);
Vue.use(Divider);
Vue.use(Popover);
Vue.use(Calendar);
Vue.use(Cascader);
Vue.use(Transfer);
Vue.use(Collapse);
Vue.use(Skeleton);
Vue.use(Progress);
Vue.use(Carousel);
Vue.use(Timeline);
Vue.use(Dropdown);
Vue.use(Checkbox);
Vue.use(FormModel);
Vue.use(Pagination);
Vue.use(Popconfirm);
Vue.use(TreeSelect);
Vue.use(TimePicker);
Vue.use(PageHeader);
Vue.use(Breadcrumb);
Vue.use(DatePicker);
Vue.use(InputNumber);
Vue.use(Descriptions);
Vue.use(ConfigProvider);
Vue.use(Statistic);
Vue.use(Rate);

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$warning = Modal.warning;

Vue.component(Button.name, Button);
